import axios from "./axios";
import { toast } from "react-toastify";
import moment from "moment";
import isEmpty from "lodash/isEmpty";

// const toFormData = data => {
//   const fd = new FormData();
//   Object.entries(data).forEach(([key, value]) => {
//     fd.append(key, value);
//   });
//   return fd;
// };

const handleError = (error) => {
	const { data } = error;
	if (data && data.message) {
		toast(data.message, { autoClose: 5000, type: toast.TYPE.ERROR });
	} else {
		toast("Something went wrong.", {
			autoClose: 5000,
			type: toast.TYPE.ERROR,
		});
	}
};

const buildQueryString = (params) => {
    const query = [];

    Object.keys(params).forEach(key => {
        const value = params[key];
        if (Array.isArray(value)) {
            value.forEach(item => {
                query.push(`${encodeURIComponent(key)}=${encodeURIComponent(item)}`);
            });
        } else {
            query.push(`${encodeURIComponent(key)}=${encodeURIComponent(value)}`);
        }
    });

    return query.join('&');
};

const login = (data) => {
	return axios.post("/users/login_with_password/", data);
};

const logout = (data) => {
	return axios.get("/users/logout/", data);
};

const loginWithGoogle = (data) => {
	return axios.post("/users/login_with_google/", data);
};

const loginWithSso = (data) => {
	return axios.post("/users/login_with_sso_key/", data);
};

const getUsers = () => {
	return axios.get("/users/");
};

const setPassword = (data) => {
	return axios.put("/password", data, { params: { forcechange: "true" } });
};

const requestResetPassword = (data) => {
	return axios.post("/password_reset/", data);
};

const resetPassword = (data) => {
	return axios.post("/password_reset/confirm/", data);
};

const forgotPassword = (data) => {
	return axios.put("/forgotpassword", data, { params: { request: "true" } });
};

const setNewPasswordPostForgot = (data) => {
	return axios.put("/forgotpassword", data);
};

const changePassword = (data) => {
	return axios.put("/password", data);
};

const getUserRoles = (data) => {
	return axios.get("/users/get_user_roles");
};

const createUser = (data) => {
	return axios.post("/users/create_user/", data);
};

const updateUser = (data) => {
	return axios.post("/users/update_user/", data);
};

const assignHandholder = (data) => {
	if ("email_ids" in data) {
		return axios.get("/service-request/assign_hand_holder/", {
			params: { ...data },
		});
	}
	return axios.post("/service-request/assign_hand_holder/", data);
};

const assignToMe = (data) => {
	if ("email_ids" in data) {
		return axios.get("/service-request/assign_to_me/", {
			params: { ...data },
		});
	}
	return axios.post("/service-request/assign_to_me/", data);
};

const assignFacilitator = (data) => {
	if ("get_request" in data) {
		return axios.get("/services/assign_facilitator/", {
			params: { ...data },
		});
	}
	return axios.post("services/assign_facilitator/", data);
};

const getAllHandholders = () => {
	return axios.get("/users/get_users_with_role/?role=hh");
};

const getAllServiceRequestsNames = () => {
	return axios.get("/service-types/");
};

const getDisableFalseServiceRequestsNames = (data) =>{
	console.log("getDisableFalseServiceRequestsNames");
	return axios.get("/service-types/", { params: {...data}});

}
const getMyServiceRequests = 
(
	handled,
	service_codes,
	statusList,
	followUpFromDate,
	followUpToDate,
	fromNum,
	toNum
) => {
	let filterParameters ={};	
	if(fromNum){
		filterParameters.from_num = fromNum;
	}
	if(toNum){
		filterParameters.to_num = toNum;
	}
	if(handled&&handled.value=='yes')
	{
		filterParameters.handled=true;
		// filterParameters.from_num = 0;
		// filterParameters.to_num = 200;
	}
	else if(handled&&handled.value=='no')
	{
		filterParameters.handled=false;
		// filterParameters.from_num = 0;
		// filterParameters.to_num = 200;
	}
	if(followUpFromDate){
		filterParameters.followUpFromDate = followUpFromDate;
		// filterParameters.from_num = 0;
		// filterParameters.to_num = 200;
	}
	if(followUpToDate){
		filterParameters.followUpToDate = followUpToDate;
		// filterParameters.from_num = 0;
		// filterParameters.to_num = 200;
	}
	if (service_codes&&service_codes.length) {
		filterParameters.service_codes = service_codes;
		// filterParameters.from_num = 0;
		// filterParameters.to_num = 200;
	}
	if (statusList&&statusList.length) {
		filterParameters.statusList = statusList;
		// filterParameters.from_num = 0;
		// filterParameters.to_num = 200;
	}
	return axios.get("/service-request/fetch_my_service_requests/", {
		params: { ...filterParameters },
	});
};

const getMyServiceRequestsFacilitator = (
	page,
	pageSize,
	sort,
	dateFilter,
	fromDate,
	toDate,
	customerFilterValue,
	customerFilter,
	statusList,
	serviceRequestList,
	PackageList,
	ServicesThroughPackage,
	IntroductoryCall,
	CallConnectedStatus,
	EngagementCallStayEngaged,
	DoesUserSharedChallenges,
	HelpForGivenChallenges
) => {
	let ques_filter ={};
	let filterParameters = { page,page_size:pageSize, ...sort };
	if (serviceRequestList.length) {
		filterParameters.service_codes = serviceRequestList;
	}
	if (statusList.length) {
		filterParameters.statusList = statusList;
	}
	/*if (customerFilter) {
		filterParameters[customerFilter["value"]] = customerFilterValue;
	}*/
	if (customerFilterValue) 
	{
		filterParameters.search_value = customerFilterValue;
	}
	if (dateFilter && fromDate && toDate) {
		filterParameters.date_field = dateFilter.value;
		if (fromDate) {
			filterParameters.date_range_from = fromDate;
		}
		if (toDate) {
			filterParameters.date_range_to = toDate;
		}
	}
	if(ServicesThroughPackage.value=='yes')
	{
		filterParameters.sourcePackage=true;
	}
	else if(ServicesThroughPackage.value=='no')
	{
		filterParameters.sourcePackage=false;
	}
	if (PackageList.length) {
		filterParameters.nPackageCatalogueIds = PackageList;
	}

	if (IntroductoryCall) {
		ques_filter["1"] = IntroductoryCall;
	}

	if (CallConnectedStatus) {
		ques_filter["2"] = CallConnectedStatus;
	}

	if (EngagementCallStayEngaged) {
		ques_filter["3"] = EngagementCallStayEngaged;
	}

	if (DoesUserSharedChallenges) {
		ques_filter["6"] = DoesUserSharedChallenges;
	}

	if (HelpForGivenChallenges) {
		ques_filter["10"] = HelpForGivenChallenges;
	}

	if (IntroductoryCall||CallConnectedStatus||EngagementCallStayEngaged||DoesUserSharedChallenges||HelpForGivenChallenges)
	{
		filterParameters.ques_filter=ques_filter;
	}

	return axios.get("services/fetch_my_services/", {
		params: { ...filterParameters },
	});
};

const getMyServiceRequestsFacilitatorV1 = (
	page,
	pageSize,
	sort,
	dateFilter,
	fromDate,
	toDate,
	customerFilterValue,
	customerFilter,
	statusList,
	serviceRequestList,
	PackageList,
	ServicesThroughPackage,
	IntroductoryCall,
	CallConnectedStatus,
	EngagementCallStayEngaged,
	DoesUserSharedChallenges,
	HelpForGivenChallenges
) => {
	let ques_filter ={};
	let filterParameters = { page,page_size:pageSize, ...sort };
	if (serviceRequestList.length) {
		filterParameters.service_codes = serviceRequestList;
	}
	if (statusList.length) {
		filterParameters.statusList = statusList;
	}
	/*if (customerFilter) {
		filterParameters[customerFilter["value"]] = customerFilterValue;
	}*/
	if (customerFilterValue) 
	{
		filterParameters.search_value = customerFilterValue;
	}
	if (dateFilter && fromDate && toDate) {
		filterParameters.date_field = dateFilter.value;
		if (fromDate) {
			filterParameters.date_range_from = fromDate;
		}
		if (toDate) {
			filterParameters.date_range_to = toDate;
		}
	}
	if(ServicesThroughPackage.value=='yes')
	{
		filterParameters.sourcePackage=true;
	}
	else if(ServicesThroughPackage.value=='no')
	{
		filterParameters.sourcePackage=false;
	}
	if (PackageList.length) {
		filterParameters.nPackageCatalogueIds = PackageList;
	}

	if (IntroductoryCall) {
		ques_filter["1"] = IntroductoryCall;
	}

	if (CallConnectedStatus) {
		ques_filter["2"] = CallConnectedStatus;
	}

	if (EngagementCallStayEngaged) {
		ques_filter["3"] = EngagementCallStayEngaged;
	}

	if (DoesUserSharedChallenges) {
		ques_filter["6"] = DoesUserSharedChallenges;
	}

	if (HelpForGivenChallenges) {
		ques_filter["10"] = HelpForGivenChallenges;
	}

	if (IntroductoryCall||CallConnectedStatus||EngagementCallStayEngaged||DoesUserSharedChallenges||HelpForGivenChallenges)
	{
		filterParameters.ques_filter=ques_filter;
	}

	return axios.get("services/fetch_my_servicesV1/", {
		params: { ...filterParameters },
	});
};

const getMyServiceRequestsFacilitatorDueToday = () => {
	return axios.get("services/fetch_my_services/", {
		params: { follow_up_today: true },
	});
};

const getMyServiceRequestsFacilitatorOverdue = () => {
	return axios.get("services/fetch_my_services/", {
		params: { follow_up_past: true },
	});
};

const deactivateUser = (email, outOfOfficeOperation = false,dtFromDate=null,dtToDate=null) => {
	if (outOfOfficeOperation&&dtFromDate&&dtToDate)
		return axios.post("/users/update_user/", {
			out_of_office: true,
			email,
			dtFromDate,
			dtToDate
		});
	else return axios.post("/users/update_user/", { is_active: false, email });
};

const deactivateUserNew = (data) => {
	return axios.post("/users/deactivate_user/", data);
};

const reactivateUser = (email) => {
	return axios.post("/users/update_user/", { is_active: true, email });
};
const markInOffice = (email) => {
	return axios.post("/users/update_user/", { out_of_office: false, email });
};

const updateServiceRequest = (data) => {
	return axios.post("/service-request/handled/", data);
};

const getMasterServiceTypes = (data) => {
	return axios.get("/service-types/");
};

const getMasterServiceStates = (data) => {
	return axios.get("/service-states/");
};

const getMasterServiceRequestStates = () => {
	return axios.get("/service-request-states/");
};

const getAuditLog = (resource_instance_id) => {
	return axios.get("/service-request-audit/", {
		params: { resource_instance_id },
	});
};

const getStateAuditLog = (resource_instance_id) => {
	return axios.get("/sr-state-changelog/", {
		params: { resource_instance_id },
	});
};

const getStateAuditLogSPM = (nResourceInstanceId) => {
	return axios.get("/service-state-change-history/log_by_service_id/", {
		params: {
			nResourceInstanceId,
		},
	});
};

const searchServiceRequests = (value) => {
	return axios.get("/service-request/", { params: { ...value } });
};
const searchServiceRequestsSPM = (value) => {
	return axios.get("/services/", { params: { ...value } });
};
const searchServiceById = (data) => {
	return axios.get(`/services/${data}`);
};

const getAllServiceRequests = (
	page,
	pageSize,
	fromDate,
	toDate,
	paymentStatus,
	statusList,
	unassigned,
	serviceRequestList,
	failedPayments,
	movedToSPMStatus,
	ServicesThroughPackage,	
	PackageList,
	searchFilter,
	sort,
	navFlag,
	pagination = true
) => {
	let filterParameters = {
		page,
		page_size:pageSize,
		...searchFilter,
		...sort,
	};

	let flag = false;
	if (pagination === false) {
		filterParameters.pagination = pagination;
	}

	if (unassigned) {
		filterParameters.unassigned_hh = unassigned;
		flag = true;
	}

	if(fromDate){
		filterParameters.fromDate = fromDate;
		flag = true;
	}
	if(toDate){
		filterParameters.toDate = toDate;
		flag = true;
	}
	if (failedPayments) {
		filterParameters.payment_failed = failedPayments;
		flag = true;
	}

	if (serviceRequestList.length) {
		filterParameters.service_codes = serviceRequestList;
		flag = true;
	}
	if (statusList.length) {
		filterParameters.statusList = statusList;
		flag = true;
	}
	if (paymentStatus.length) {
		filterParameters.payment_status = paymentStatus;
		flag = true;
	}
	if(movedToSPMStatus.value=='yes')
	{
		filterParameters.bMovedToSPM=true;
		flag = true;
	}
	else if(movedToSPMStatus.value=='no')
	{
		filterParameters.bMovedToSPM=false;
		flag = true;
	}
	if(ServicesThroughPackage.value=='yes')
	{
		filterParameters.sourcePackage=true;
		flag = true;
	}
	else if(ServicesThroughPackage.value=='no')
	{
		filterParameters.sourcePackage=false;
		flag = true;
	}
	if (PackageList.length) {
		filterParameters.nPackageCatalogueIds = PackageList;
		flag = true;
	}

	if (isEmpty(searchFilter) === false) {
		flag = true;
	}
	if (navFlag == false) {
		delete filterParameters.page;
	}
	
	return axios.get("/service-request/", { params: { ...filterParameters } });
};

const getAllServiceRequestsStatus = () => {
	return axios.get("/service-request-states/");
};

const sendPaymentLink = (data) => {
	return axios.post("/payment/send-payment-link-sr/", data);
};

const changeServiceRequestState = (data) => {
	return axios.post("/service-request/change_state/", data);
};

const getServiceRequestById = (id) => {
	return axios.get(`/service-request/${id}`);
};

const getCatalogueForServiceRequest = (service_code) => {
	return axios.get("/service-catalogue/", { params: { service_code } });
};

const saveCatalogueForServiceRequest = (data) => {
	return axios.post("/service-request/save_catalogue_sr/", data);
};

const saveNeftDetails = (data) => {
	return axios.post("/service-request/update_neft_details/", data);
};

const saveNeftDetailsSPM = (data) => {
	return axios.post("/services/update_neft_details/", data);
};
const getUserProfileData = (data) => {
	return axios.post("/user_profile/get_user_profile/", data);
};
const getUserProfileWP = (data) => {
	return axios.get("/user_profile/get_user_profile_wp/", {
		params: { ...data },
	});
};
const getUserMetaChangeLog = (data) => {
	return axios.get("/user_profile/get_user_change_log/", {
		params: { ...data },
	});
};

const getUserProfileSupportedStatusHistory = (data) => {
	return axios.post("/user_profile/get_supported_status_history/", data);
};

const saveUserProfileData = (data) => {
	return axios.post("/user_profile/save_user_profile/", data);
};
// const getAllCustomers = () => {
//   return axios.get("/customer");
// };

const getAllServicesReport = (data) => {
	return axios.get("/reports/all_services_report_view/", {
		params: { ...data },
	});
};

const getFullfillmentReport = (data) => {
	return axios.get("/reports/request_to_fulfillment_report/", {
		params: { ...data },
	});
};

const getTicketLevelLog = (data) => {
	return axios.get("/reports/ticket_level_log/", {
		params: { ...data },
	});
};

const getAllServicesReportView = (data) => {
	return axios.post("/reports/all_services_report_view/", data);
};

const getUserRoleAccessReport = (data) => {
	return axios.get("/reports/user_role_access_report/", data);
};

const getRoleAccessReport = (data) => {
	return axios.get("/reports/role_access_report/", data);
};
const getAuditLogReport = (data) => {
	return axios.get("/reports/audit_log_report/", { params: { ...data } });
};
const getServiceCatalogueReport = (data) => {
	return axios.get("/reports/service_catalogue_report/", data);
};
const getServiceActionReport = (data) => {
	return axios.get("/reports/service_action_report_view/", {
		params: { ...data },
	});
};
const getKRAReport = (data) => {
	return axios.get("/reports/kra_report_view/", {
		params: { ...data },
	});
};
const generateCallingReport = (data) => {
	return axios.get("/reports/generate_calling_report/", data);
};
const getPaymentTrackerReport = (data) => {
	return axios.get("/reports/generate_payment_tracker_report/", data);
};

const getleadDetails = (searchParameters) => {
	let filterParameters = { ...searchParameters };
	return axios.get("/lead-data/get_lead_details/", {
		params: { ...filterParameters },
	});
};

const getAllServicesSPM = (
	page,
	pageSize,
	paymentStatus,
	statusList,
	unassigned,
	serviceRequestList,
	followupInPast,
	followupToday,
	failedPayments,
	ServicesThroughPackage,	
	PackageList,
	searchFilter,
	sort,
	navFlag,
	pagination = true
) => {
	let filterParameters = {
		page,
		page_size:pageSize,
		...searchFilter,
		...sort,
	};
	if (pagination === false) {
		filterParameters.pagination = pagination;
	}
	let flag = false;

	if (unassigned) {
		filterParameters.unassigned_facilitator = unassigned;
		flag = true;
	}

	if (followupInPast) {
		filterParameters.follow_up_past = followupInPast;
		flag = true;
	}
	if (failedPayments) {
		filterParameters.payment_failed = failedPayments;
		flag = true;
	}
	if (followupToday) {
		filterParameters.follow_up_today = followupToday;
		flag = true;
	}
	if (serviceRequestList.length) {
		filterParameters.service_codes = serviceRequestList;
		flag = true;
	}
	if (statusList.length) {
		filterParameters.statusList = statusList;
		flag = true;
	}

	if(ServicesThroughPackage.value=='yes')
	{
		filterParameters.sourcePackage=true;
		flag = true;
	}
	else if(ServicesThroughPackage.value=='no')
	{
		filterParameters.sourcePackage=false;
		flag = true;
	}
	if (PackageList.length) {
		filterParameters.nPackageCatalogueIds = PackageList;
		flag = true;
	}
	
	if (paymentStatus.length) {
		filterParameters.payment_status = paymentStatus;
		flag = true;
	}
	if (isEmpty(searchFilter) === false) {
		flag = true;
	}
	if (navFlag == false) {
		delete filterParameters.page;
	}

	return axios.get("/services/", { params: { ...filterParameters } });
};

const getAllFacilitators = () => {
	return axios
		.get("/users/get_users_with_role/?role=facilitator")
		.then((data) => {
			return data;
		});
};

const getNotesHistory = (data) => {
	return axios.get("/service-actions/action_by_service_id/", {
		params: { ...data },
	});
};

const saveNotes = (data) => {
	return axios.post("/service-actions/", data);
};

const updateNotes = (data) => {
	return axios.post("/service-actions/update_service_action/", data);
};

const addExpertSlots = (data) => {
	return axios.post("/add_calendar_slot/", data)
}

const deleteExpertSlots = (data) => {
	return axios.post("/delete_calendar_slot/", data)
}

const getAllServiceActions = (
	page,
	sort,
	dateFilter,
	fromDate,
	toDate,
	customerFilterValue,
	customerFilter,
	showIncompleteActions
) => {
	let filterParameters = { page, ...sort };
	if (showIncompleteActions)
		filterParameters.completed = !showIncompleteActions;

	if (customerFilter) {
		filterParameters["filter_by"] = customerFilter["value"];
		filterParameters["filter_value"] = customerFilterValue;
	}
	if (dateFilter && fromDate && toDate) {
		filterParameters.date_field = dateFilter.value;
		if (fromDate) {
			filterParameters.date_range_from = fromDate;
		}
		if (toDate) {
			filterParameters.date_range_to = toDate;
		}
	}
	return axios.get("/service-actions/manage_service_action/", {
		params: { ...filterParameters },
	});
};

const getAuditTrailNotesSPM = (data) => {
	let combinedData = [];
	let resource_instance_id = data["nResourceInstanceId"];
	return axios
		.get("/service-audit-log/log_by_service_id/", {
			params: { ...data },
		})
		.then((f) => {
			combinedData = combinedData.concat(f.data);
			return f.data;
		});

	// return axios
	//   .get("/service-request-audit/", {
	//     params: { resource_instance_id },
	//   })
	//   .then((d) => {
	//     combinedData = combinedData.concat(d.data);
	//     console.log("d.data", d.data);
	//     // return d.data;
	//     return combinedData;
	//   });
};

const sendPaymentLinkSPM = (data) => {
	return axios.post("/payment/send-payment-link-service/", data);
};

const getServicePartners = (data) => {
	return axios.get("/users/get_users_with_role/?role=service-partner", data);
};

const getExternalServicePartners = (data) => {
	return axios.get("/services/fetch_ext_service_partner/", {
		params: { ...data },
	});
};

const saveServicePartner = (data) => {
	return axios.post("/services/assign_service_partner/", data);
};
const updateUserId = (data) => {
	return axios.post("/service-request/update_user_id/", data);
};

const setServiceDeliveryStarted = (data) => {
	return axios.post("/services/service_delivery_started/", data);
};

const setPaymentConfirmedbyPartner = (data) => {
	return axios.post("/services/payment_confirmed_by_partner/", data);
};

const setInfoDocsReceived = (data) => {
	return axios.post("/services/info_docs_received/", data)
}

const setServiceDeliverablesReady = (data) => {
	return axios.post("/services/service_deliverables_ready/", data);
};

const setFullPaymentRequested = (data) => {
	return axios.post("/services/full_payment_requested/", data);
};

const setFullPaymentComplete = (data) => {
	return axios.post("/services/full_payment_complete/", data);
};

const setServiceDelivered = (data) => {
	return axios.post("/services/service_delivered/", data);
};

const setServiceCancelled = (data) => {
	return axios.post("/services/service_cancelled/", data);
};

const downloadResourceData = (data) => {
	return axios.post("/user_profile/get_resources_data/", data);
};
const generateOutboundCallingLog = (data) => {
	return axios.post("/reports/generate_outbound_calling_log/", data, {
		headers: {
			"Content-Type": "multipart/form-data",
		},
	});
};
const downloadOutboundLogs = () => {
	return axios.get("/reports/generate_outbound_calling_log/");
};
const saveBusinessProfile = (data) => {
	return axios.post("/user_profile/save_business_profile/", data);
};
const findDetailsWithPincode = (pincode) => {
	return axios.post("/utilities/get_pincode_data/", pincode);
};

const getCancellationReasons = () => {
	return axios.get("/service-cancellation-reason/");
};

const getNeftAccountDetails = () => {
	return axios.get("/utilities/get_deasra_neft_details/");
}

const sendNeftAccountDetails = (email) => {
	return axios.post("/utilities/send_deasra_neft_details/", email);
};

const getDNDDate = (email) => {
	return axios.post("/user_profile/get_dnd_date/", email);
};

const saveRefundDetails = (data) => {
	return axios.post("/services/update_refund_details/", data);
};

const getAllPackageCatalogues = (data) => {
	return axios.get("/package-catalogue/",{
		params: { ...data },
	});
};

const createPackageCatalogue = (data) => {
	return axios.post("/package-catalogue/", data);
};

const getAllServiceCatalogues = () => {
	return axios.get("/service-catalogue/");
};

const getAllExternalServicePartners = () => {
	return axios.get("/external-service-partner/");
};

const getPackageMappedServices = (data) => {
	return axios.get("/package-service-mapping/",{
		params: { ...data },
	});
};

const bookExpertAppointment =(data) => {
	return axios.post("/book-appointment-v2/", data)
}


const mapPackageServices = (data) => {
	return axios.post("/package-service-mapping/",data);
};

const updatePackageCatalogue = (id,data) => {
	return axios.patch("/package-catalogue/"+id+"/", data);
};

const deletePackageMappedService = (id) => {
	return axios.delete("/package-service-mapping/"+id+"/");
};

const getExternalPartnerServices = (filterParameters) => {
	return axios.get("/external-partner-services/", { params: { ...filterParameters } });
};

const sendOTPToESP = (data) => {
	return axios.post("/users/send_otp/",data);
};

const loginESPWithOTP = (data) => {
	return axios.post("/users/login_with_ext_serice_partner/",data);
};

const updateOtherServiceInfo = (data) => {
	return axios.post("/update-other-service-info/",data);
};

const setAwaitingForInformationDocuments = (data) => {
	return axios.post("/services/awaiting_for_information/", data);
};

const addESPServiceCharges = (data) => {
	return axios.post("/ext-sp-charges/", data);
};

const updateESPServiceCharges = (id,data) => {
	return axios.patch("/ext-sp-charges/"+id+"/", data);
};

const addESPNotes = (data) => {
	return axios.post("/ext-sp-notes/", data);
};

const getESPNotesLogByServiceId = (data) => {
	return axios.get("/ext-sp-notes/log_by_service_id/",{
		params: { ...data },
	});
};

const updateNeedtoTalkToSPFlagSPM = (id,data) => {
	return axios.patch("/services/"+id+"/", data);
};

const updateCallStatus = (data) => {
	return axios.post("/update-call-status/",data);
};

const sendClaimFreeListingSMSToUser = (data) => {
	return axios.post("/services/send_claimfreelisting_sms/", data);
};
const updateNewNotesFlag = (data) => {
	return axios.post("/update-new-notes-flag/",data);
};

const getExternalPartnerServicesDashboradData = (data) => {
	return axios.post("/dashboard/ext_service_partner/", data);

};

// const getExternalPartnerServicesDashboradDataNew = (data) => {
// 	return axios.post("/dashboard/ext_service_partner_details/", data);

// };

const getExternalPartnerServicesDashboradDataNew = (data) => {
	return axios.post("/dashboard/ext_service_partner_details_new/", data);

};

const getExternalPartnerServicesChartData = (data) => {
	return axios.post("/dashboard/ext_service_partner_all_count/", data);

};

const getExternalPartnerServicesCountData = (data) => {
	return axios.post("/dashboard/ext_service_partner_count/", data);

};

const getUserQuestionnaire = (data) => {
	return axios.get("/questionnaire/fetch_user_questions/", {
		params: { ...data },
	});
};

const getUserBusinessQuestionnaire = (data) => {
	return axios.get("/questionnaire/fetch_business_questions/", {
		params: { ...data },
	});
};

const updateUserQuestionaireData = (data) => {
	return axios.post("/questionnaire/update_user_questionnaire_data/", data);
};

const updateUserBusinessQuestionaireData = (data) => {
	return axios.post("/questionnaire/update_business_questionnaire_data/", data);
};

const getUserAllServiceFeedbackData = (data) => {
	return axios.post("/user_profile/get_all_feedbacks/", data);
};

const getUserServiceFeedbackData = (data) => {
	return axios.post("/user_profile/get_feedback_data/", data);
};

const getImpactMetricReport = (data) => {
	return axios.get("/reports/generate_impact_metric_report/", data);
};

const getImpactMetricTransactionReport = (data) => {
	return axios.get("/reports/generate_impact_metric_transactions/", data);
};

const getEngagementReport = (data) => {
	return axios.get("/reports/generate_engagement_report/", data);
};

const getUserFeedbackReport = (data) => {
	return axios.get("/reports/generate_feedback_report/", data);
};

const getNotesLogByEmailId = (data) => {
	return axios.get("/ext-sp-notes/get_log_by_email_id/",{
		params: { ...data },
	});

};

const updatedePrenuerDetails = (data) => {
	return axios.post("/user_profile/update_deprenuer_details/", data);
};

const getFacilitatorKRADashboardData = (data) => {
	return axios.post("/dashboard/facilitaor_dashboard/", data);

};

const UploadAdminKRAReport = (data) => {
	return axios.post("/dashboard/import_dashboard_data/", data, {
		headers: {
			"Content-Type": "multipart/form-data",
		},
	});
};

const getFacilitatorManagersKRADashboardData = (data) => {
	return axios.post("/dashboard/facilitator_manager_dashboard/", data);

};

const getProfileSearchFields = () => {
	return axios.get("/datamart/get_profile_fields/");
};

const getUserProfileSearchReport = (data) => {
	return axios.post("/datamart/generate_report/", data);

};

const updatedePrenuerBusinessData = (data) => {
	return axios.post("/update_depreneur_business_data/",data);
};

const updatedePrenuerServiceVerifiedFlag = (data) => {
	return axios.post("/update_depreneur_service_varified_flag/",data);
};

const getActiveHHAndFacilitator = () => {
	return axios.get("/users/get_users_with_role/?role=hh,facilitator");
};

const sendFollowupSMS = (data) => {
	return axios.post("/send_followup_sms_to_user/",data);
};

const getESPSMSLogByServiceId = (data) => {
	return axios.get("/all_followup_sms/",{
		params: { ...data },
	});
};

const getAllFollowupSMSByUserid = (data) => {
	return axios.get("/all_followup_sms_by_userid/",{
		params: { ...data },
	});

};

const getSMSTrailReport = (data) => {
	return axios.get("/reports/generate_sms_trail_report/", {
		params: { ...data },
	});
};

const getCustomerFeedbackList = (data) => {
	return axios.post("/customer_feedback_list/", data);
};

const getFirstTimeResponseData = (data) => {
	return axios.post("/first_time_response_data/",data);
};

const getCustomerSatisfactionScoreData = (data) => {
	return axios.post("/customer_satisfaction_score/",data);
};

const getCustomerFeedbackReport = (data) => {
	return axios.get("/reports/generate_feedback_report/", {
		params: { ...data },
	});
};

const getCustomerFRTReport = (data) => {
	return axios.get("/reports/generate_frt_report/", {
		params: { ...data },
	});
};

const getUMCReport = (data) => {
	return axios.get("/reports/request_to_fulfillment_report_umc/", {
		params: { ...data },
	});
}

const sendFeedbackLinkToUser = (data) => {
	return axios.post("/send_emailsms_for_delivered_services/", data);
};

const getServiceDetailsLPMByInstanceID = (data) => {
	return axios.get(`/service-request/${data}`);
};

const getServiceDetailsSPMByInstanceID = (data) => {
	return axios.get(`/services/${data}`);
};

const getUnreadFeedbackCount = (data) => {
	return axios.get("/unread_feedbacks/", {
		params: { ...data },
	});
};

const uploadAssignFacilitatorData = (data) => {
	return axios.post("/dashboard/update_facilitator_data/", data, {
		headers: {
			"Content-Type": "multipart/form-data",
		},
	});
};

const getKRADashboardReport = (data) => {
	return axios.post("/reports/generate_dashboard_detail_report/",data);
};

const UploadStatusProgressionSheet = (data) => {
	return axios.post("/import_Service_data_upload/", data, {
		headers: {
			"Content-Type": "multipart/form-data",
		},
	});
};

const updateNeedToTalkToSPFlagFromSPLed = (data) => {
	return axios.post("/update_need_to_talk_SP_flag/",data);
};

const updateSPFollowUpData = (data) => {
	return axios.post("/update-followup/",data);
};

const getSPLedFollowUps = () => {
	return axios.get("/list-followup/");
};

const getDNDUsersList = (data) => {
	return axios.post("/dnd_data_services/",data);
};
const saveESPTargets = (data) => {
	return axios.post("/dashboard/target_configuration/", data);
};

const getServiceRequests = (filterParameters) => {
	return axios.get("/service-request/", { params: { ...filterParameters } });
};

const getServicesSPM = (filterParameters) => {
	// // old endpoint for spm all services
	// return axios.get("/services/", { params: { ...filterParameters } });

	// new endpoint for spm all services
	return axios.get("/services/spm_get_all_services/", { params: { ...filterParameters } });
};

//This is for new facilitator view container
const getFacilitatorServiceActions = (filterParameters
) => {	
	return axios.get("/service-actions/manage_service_action/", {
		params: { ...filterParameters},
	});
};
const get2_plus_3_plusReport = (data) => {
	return axios.post("/reports/generate_2_plus_3_plus_report/", data);
};


const getEngagedUserReport = (data) => {
	return axios.post("/reports/engaged_users_report/", data);
};

const getFirstTimeUserReport = (data) => {
	return axios.get("/reports/first_time_users_report/", data)
}



const getToolsTemplateList=(data)=>{
		return axios.get("/tools-template/", data);
};

const searchToolsTemplateRequests = (value) => {
	return axios.get("/tools-template/", { params: { ...value } });
};

const getToolTemplatesRequests = (filterParameters) => {
	// console.log('filterParameters',filterParameters)
	return axios.get("/tools-template/", { params: { ...filterParameters } });
};

// const getAllPackageToolsTemplates = (data) => {
// 	return axios.get("/tools-template/",{
// 		params: { ...data },
// 	});
// };

const getToolsTemplatesTool = (filterParameters) => {
	return axios.get("/tools-template/list_tools_template/?sType=Tool", { params: { ...filterParameters } });
};

const getToolsTemplatesTemplate = (filterParameters) => {
	return axios.get("/tools-template/list_tools_template/?sType=Template", { params: { ...filterParameters } });
};

const getFacilitatorCallReport = (data) => {
	return axios.post("/reports/generate_facilitator_call_report/",data);
};

const getengagedusercount = (data) => {
	return axios.get("/record-transaction/engaged_users_count_report/",{ params: { ...data } });
};

const getFirstTimeusersDashboradData = (data) => {
	return axios.get("/record-transaction/first_time_users_resources_report/", { params: { ...data } });

};

const getEngagedusersDashboradData = (data) => {
	return axios.get("/record-transaction/engaged_users_resources_report/", { params: { ...data } });

};

const getFirstTimeUserPartnerData = (data) => {
	return axios.get("/record-transaction/first_time_users_entrypoint_report/", {params: {...data}})
}

const getEngagedUserPartnerData = (data) => {
	return axios.get("/record-transaction/engaged_users_entrypoint_report/", {params: {...data}})
}

const getFirstTimeAnnualTurnover = (data) => {
	return axios.get("/record-transaction/first_time_users_turnover_report/", {params: {...data}})
}

const getEngagedAnnualTurnover = (data) => {
	return axios.get("/record-transaction/engaged_users_turnover_report/", {params: {...data}})
}

const getFirstTimeSourceMediumData = (data) => {
	return axios.get("/record-transaction/first_users_source_medium_report/", {params: {...data}})
}

const getEngagedSourceMediumData = (data) => {
	return axios.get("/record-transaction/engaged_users_source_medium_report/", {params: {...data}})
}

const getFirstTimeUserChartData = (data) => {
	return axios.get("/record-transaction/first_time_users_graph_report_v2/", {params: {...data}})
}

const getEngagedUserChartData = (data) => {
	return axios.get("/record-transaction/engaged_users_graph_report_v2/", {params: {...data}})
}

const getResourceAwailedChartData = (data) => {
	return axios.get("/record-transaction/awailed_monthwise_graph/", {params: {...data}})
}

const getMonthWiseData = (data) => {
	return axios.get("/record-transaction/monthwise_graph/", {params: {...data}})
}

const getResourceCount = (data) => {
	return axios.get("/record-transaction/first_engaged_user_count/", {params: {...data}})
}

const getFirstTimeProgramData = (data) => {
	return axios.get("/record-transaction/first_time_users_resourcesID_report/", {params: {...data}})
}

const getEngagedUserProgramData = (data) => {
	return axios.get("/record-transaction/engaged_users_resourcesID_report/", {params: {...data}})
}

const getFilterPartnerData = (data) => {
	return axios.get("/record-transaction/first_engaged_time_users_sPackageTitle_report/", {params: {...data}})
}

const getFilterProgramData = (data) => {
	return axios.get("/record-transaction/engaged_and_first_engaged_time_users_ProgramandPartner_report/", {params: {...data}})
}

const getFirstTimePartnerResourceData = (data) => {
	return axios.get("/record-transaction/first_users_entrypoint_displayname_report/", {params: {...data}})
}

const getEngagedPartnerResourceData = (data) => {
	return axios.get("/record-transaction/engaged_users_entrypoint_displayname_report/", {params: {...data}})
}

const getFirstTimeProgramResourceData = (data) => {
	return axios.get("/record-transaction/first_users_packagetitle_displayname_report/", {params: {...data}})
}

const getEngagedProgramResourceData = (data) => {
	return axios.get("/record-transaction/engaged_users_packagetitle_displayname_report/", {params: {...data}})
}

const getAllExpertCalenderList = () => {
	return axios.get("/get-all-expert-calender-list/")
}

const getAllExpertAppointmentList = () => {
	return axios.get("/get-all-expert-appointment-list/")
}
const getFacilitatorCount = (data) => {
	return axios.get("/services/facilitator_assigned_count_new/", {params: {...data}});
}

const getSingleUserFacilitatorData = (data) => {
	return axios.get("/services/users_with_single_facilitator_list_new/", {params: {...data}})
}

const getMultipleUserFacilitatorData = (data) => {
	return axios.get("/services/users_with_multiple_facilitator_list_new/", {params: {...data}})
}

const getAllToolsTemplatesRequests = (
	page,
	pageSize,
	searchFilter,
	sort,
	navFlag,
	pagination = true
) => {
	let filterParameters = {
		page,
		page_size:pageSize,
		...searchFilter,
		...sort,
	};

	let flag = false;
	if (pagination === false) {
		filterParameters.pagination = pagination;
	}


	if (isEmpty(searchFilter) === false) {
		flag = true;
	}
	if (navFlag == false) {
		delete filterParameters.page;
	}
	
	return axios.get("/tools-template/", { params: { ...filterParameters } });
};


const getMyResourceToolsTemplates = (
	page,
	pageSize,
	sort,
	customerFilterValue,
	pagination = true
) => {
	let ques_filter ={};
	let filterParameters = { page,page_size:pageSize, ...sort };
	if (pagination === true) {
		filterParameters.pagination = pagination;
	}
	/*if (customerFilter) {
		filterParameters[customerFilter["value"]] = customerFilterValue;
	}*/
	if (customerFilterValue) 
	{
		filterParameters.search_value = customerFilterValue;
	}
	
	

	return axios.get("/tools-template/", {
		params: { ...filterParameters },
	});
};

const getToolsTemplatesDueToday = () => {
	return axios.get("services/fetch_my_services/", {
		params: { follow_up_today: true },
	});
};

const getToolsTemplatesOverdue = () => {
	return axios.get("services/fetch_my_services/", {
		params: { follow_up_past: true },
	});
};

// const getCatalogueForToolsTemplates = (sResourceType) => {
// 	return axios.get("/tools-template/", { params: { sResourceType } });
// };

const assignFacilitatorfortooltemplates = (data) => {
	if ("nUserId" in data) {
		return axios.post("/tools-template/assign_facilitator/", {
			params: { ...data },
		});
	}
	return axios.post("tools-template/assign_facilitator/", data);
};

const getFacilitatorToolsTemplatesAction = (filterParameters
	) => {	
		return axios.get("/toolstemplate-actions/manage_toolstemplate_action/", {
			params: { ...filterParameters },
		});
	};



	const getNotesfortooltemplates = (data) => {
		return axios.get("/toolstemplate-actions/manage_toolstemplate_action/",{
			params: { ...data },
		});
	
	};





// const getToolsTmpaltesNotesHistory = (data) => {
// 	return axios.post("/toolstemplate-actions/", {
// 		params: { ...data },
// 	});
// };

const saveToolsTemplatesNotes = (data) => {
	return axios.post("/toolstemplate-actions/", data);
};

// const updateToolsTemplatesNotes = (data) => {
// 	return axios.post("/toolstemplate-actions/", data);
// };

// const updateOfflineMeet = (id,data) => {
// 	return axios.post("/service-request/update_offline_meet/"+id+"/", data);
// };

const updateOfflineMeet = (data) => {
	return axios.post("/service-request/update_offline_meet/", data);
};

 
const LTExpServicePartners = (data) => {
	return axios.get("/services/fetch_ext_service_partner/?sServiceCode=LTEXP", data)
}

const LTExpCoachServicePartners = (data) => {
	return axios.get("/services/fetch_ext_service_partner/?sServiceCode=LTEXPCOACH", data)
}

const ExpConsultServicePartners = (data) => {
	return axios.get("/services/fetch_ext_service_partner/?sServiceCode=EXPRTCONSULT", data)
}

const GRPExpConsultServicePartners = (data) => {
	return axios.get("/services/fetch_ext_service_partner/?sServiceCode=GRPEXPRTCONSULT", data)
}

const updateExternalServicePartner = (data) => {
	return axios.post("/service-request/update_externalservicepartner_id/", data);
};

const getExpertById = (id) => {
	return axios.get(`/get-expert-calender/${id}/`)
}
const getExpertInfo = (data) => {
	return axios.post("https://www.deasra.in/wp-json/GetExpertPackageDetails/", data)
} 

const getSpeakerList = (data) => {
	return axios.post("https://www.deasra.in/wp-json/GetSpeakersList/", data)
}

const deleteExpertAppointment = (data) => {
	return axios.post("/delete-appointment/", data)
}

// const getVerifiedStatus = (data) => {
// 	return axios.post("https://dev.deasra.in/wp-json/getBusinessVerificationStatus/", data)
// }

const updatePriceApi = (data) => {
	return axios.post("/payment/update_amount/", data)
}

const applyDiscountAPI = (data) => {
	return axios.post("/payment/apply-discount-to-service/", data)
}

const newDeactivateUser =  (email, outOfOfficeOperation = false,dtFromDate=null,dtToDate=null) => {
	if (outOfOfficeOperation&&dtFromDate&&dtToDate)
		return axios.post("/users_post/update_user/", {
			out_of_office: true,
			email,
			dtFromDate,
			dtToDate
		});
	else return axios.post("/users_post/update_user/", { is_active: false, email });
};

const newMarkInOffice = (email) => {
	return axios.post("/users_post/update_user/", { out_of_office: false, email });
};

const allExtPartnerList = (data) => {
	return axios.get("/services/get_all_ext_service_partner/", data)
}

const monthlyPaymentTrackerReport = (data) => {
	return axios.get("/reports/generate_settlement_payment_tracker_report_new/", {params: {...data}})
}

const getServiceForSettlement = (filterParameters) => {
	return axios.get("/service-request/fetch_invoice_settlement_services/", { params: { ...filterParameters } });
};

const updateSettlementInvoice = (data) => {
	return axios.post("/service-request/update_invoice_settlement/", data);
};

const mainTableData = (data) => {
	return axios.get("/combined_resourcedisplayname/", {params: {...data}})
}

const ageWiseData = (data) => {
	return axios.get("/age_resourcedisplayname/", {params: {...data}})
}

const sectorWiseData = (data) => {
	return axios.get("/b_sector_resourcedisplayname/", {params: {...data}})
}

const familyIncomeData = (data) => {
	return axios.get("/family_income_resourcedisplayname/", {params: {...data}})
}

const businessIncomeData = (data) => {
	return axios.get("/bus_income_resourcedisplayname/", {params: {...data}})
}

const jpmcCountData = (data) => {
	return axios.get("/record-transaction-jpmc/", {params: {...data}})
}

const anekCountData = (data) => {
	return axios.get("/record-transaction-eligible_count/", {params: {...data}})
}

const totalBeneficiaryChartData = (data) => {
	return axios.get("/combined_jpmc_data/", {params: {...data}})
}

const jpmcExpenseTableData = (data) => {
	return axios.get("/record-transaction-jpmc-expenses/", {params: {...data}})
}

const getPrimeSubscriberList = (data) => {
	return axios.get("/get_primelist/", data)
}

const getPrimeServiceList = (userId) => {
    return axios.get(`/get_prime_service_list/?nUserId=${userId}`);
}

const getPrimeMarketLinkageList = (userId) => {
    return axios.get(`/get_marketlinkagelist/?nUserId=${userId}`);
}

const closeService = (data) => {
	return axios.post("/service-request/Close_LT_Service/", data)
}

const getCloseServicesData = (filterParameters) => {
	return axios.get("/service-request/get_closed_lt_services/", { params: { ...filterParameters } });
};

const openService = (data) => {
	return axios.post("/service-request/Open_LT_Service/", data)
}

const createNewServiceApi = (data) => {
	return axios.post("https://www.deasra.in/wp-json/create-longterm-package-service/", data)
}

const sendErrorEmail = (data) => {
	return axios.post("/service-request/Send_Error_Email_LT_Service/", data)
}

const getComplianceReportAPI = (data) => {
	return axios.get('/reports/jpmc_compliance/', {params: {...data}})
}

const getMarketLinkageReport = (data) => {
	return axios.get('/reports/jpmc_market_linkage/', {params: {...data}})
} 

const getGroupKnowledgeReport = (data) => {
	return axios.get('/reports/jpmc_group_knowledge_session/', {params: {...data}})
}

const getDEPSessionReport = (data) => {
	return axios.get('/reports/jpmc_Digital_Enablement_all_data/', { params: { ...data } })
}

const getMobilizationReport = (data) => {
	return axios.get('/reports/eligible_report/', {params: {...data}})
}

const getBlrpReport = (data) => {
	return axios.get('/reports/jpmc_blrp/', {params: {...data}})
}
const getDepReport = (data) => {
	return axios.get('/reports/jpmc_Digital_Enablement/', { params: { ...data } })
}

const getExpertConsultationReport = (data) => {
	return axios.get('/reports/jpmc_expert_consultation/', {params: {...data}})
}

const getJpmcAllData = (data) => {
	return axios.get("/reports/jpmc_firsttimeusers/", {params: {...data}})
}

const mobilizationCountApi = (data) => {
	return axios.post("https://www.deasra.in/wp-json/jpmc_count/", data)
}

const mobilizationCountAnekApi = (data) => {
	return axios.post("https://www.deasra.in/wp-json/anek_count/", data)
}

const getComplianceReportDataAPI = (data) => {
	return axios.get('/reports/jpmc_compliance_data/', {params: {...data}})
}

const getMarketLinkageReportData = (data) => {
	return axios.get('/reports/jpmc_market_linkage_data/', {params: {...data}})
} 

const getGroupKnowledgeReportData = (data) => {
	return axios.get('/reports/jpmc_group_knowledge_session_data/', {params: {...data}})
}
const getDigitalEnablementReportData = (data) => {
	return axios.get('/reports/jpmc_Digital_Enablement_data/', { params: { ...data } })
}


const getBlrpReportData = (data) => {
	return axios.get('/reports/jpmc_blrp_data/', {params: {...data}})
}

const getExpertConsultationReportData = (data) => {
	return axios.get('/reports/jpmc_expert_consultation_data/', {params: {...data}})
}

const getMyServiceRequestNew =
	(
		handled,
		service_codes,
		statusList,
		followUpFromDate,
		followUpToDate,
	) => {
		let filterParameters = {};
		if (handled && handled.value == 'yes') {
			filterParameters.handled = true;
		}
		else if (handled && handled.value == 'no') {
			filterParameters.handled = false;
		}
		if (followUpFromDate) {
			filterParameters.followUpFromDate = followUpFromDate;
		}
		if (followUpToDate) {
			filterParameters.followUpToDate = followUpToDate;
		}
		if (service_codes && service_codes.length) {
			filterParameters.service_codes = service_codes;
		}
		if (statusList && statusList.length) {
			filterParameters.statusList = statusList;
		}
		console.log("FilterParams=", filterParameters)
		return axios.get("/service-request/fetch_my_service_requestsv1/", {
			params: { ...filterParameters },
		});
	};

const getServiceMoreDetails = (nResourceInstanceId) => {
	return axios.get("/service-request/fetch_my_service_requestsv2/", {
		params: {
			nResourceInstanceId,
		},
	})
}

const umcOppurtunitiesOfUserApi = (data) => {
	return axios.get("/umc_data/", {params: {...data}})
}

const umcOppurtunitiesOfUserApiAllDetails = (data) => {
	return axios.get("/umc_data_awailed_details_with_dtdelivery/", { params: { ...data } })
}

const catalogueLinkApi = (data) => {
	return axios.post("https://www.deasra.in/wp-json/user-catalogue/", data)
}

const updateConfirmationFlagLPM = (nResourceInstanceId, flag) => {
	return axios.post(`/update_service_request_confirmation_flag/?nResourceInstanceId=${nResourceInstanceId}&bConfirmation_tag=${flag}`)
}

const updateConfirmationFlagSPM = (nResourceInstanceId, flag) => {
	return axios.post(`/update_service_confirmation_flag/?nResourceInstanceId=${nResourceInstanceId}&bConfirmation_tag=${flag}`)
}

const oppTypeListApi = (data) => {
	return axios.get("/service-request/get_uml_opportunity_types/", data)
}

const oppTitleListApi = (data) => {
	return axios.get("/service-request/get_uml_opportunity_titles/", {params: {...data}})
}

const deliverBulkServiceData = (data) => {
	return axios.post("/update_umc_state/", data)
}

const cancelBulkServiceData = (data) => {
	return axios.post("/update_umc_cancel_state/", data)
}

const umcDataReport = (data) => {
	return axios.get("/reports/umc_data_report/", {params: {...data}})
}

const addRevenueUmc = (data) => {
	return axios.post("/add_umc_revenue/", data)
}

const businessSectorListApi = (data) => {
	return axios.get("/business_sector/", data)
}

const businessCityListApi = (data) => {
	return axios.get("/business_city/", data)
}

const tagsListApi = (data) => {
	return axios.get(`/reports/sector_tags/?sSector=${data}`)
}

const productListApi = (data) =>{
	return axios.get("/reports/get_distinct_productlist/", data)
}

const fetchTagsByUserId = (data) => {
	return axios.get(`/reports/get_tags_by_user_id/?nUserId=${data}`)
}

const saveTagsApi = (data) => {
	return axios.post("/reports/add_customer_sector_tags/", data)
}

const umcCustomersAPI = (data) => {
	return axios.get('/umc_data_distinct/', {params: {...data}})
}

const umcCustomerDownlaodApi = (data) => {
	return axios.get("/reports/umc_data_distinct_report/", {params: {...data}})
}

const getExternalPartnerUmcServices = (filterParameters) => {
	return axios.get("/external-partner-umc-services/", { params: { ...filterParameters } });
};

const getExternalPartnerFilterConfirmationTag = (filterParameters) => {
	return axios.get("/get_ext_sp_data_filterby_confirmationtag/", { params: { ...filterParameters } });
};

const getGroupKnowledgeSessionReport = (data) => {
	return axios.get('/reports/jpmc_group_knowledge_session_all_data/', { params: { ...data } })
}

const getMarketLinkageSessionReport = (data) => {
	return axios.get('/reports/jpmc_market_linkage_all_data/', { params: { ...data } })
}

const getComplianceSessionReport = (data) => {
	return axios.get('/reports/jpmc_compliance_all_data/', { params: { ...data } })
}

const getExpertConsultationSessionReport = (data) => {
	return axios.get('/reports/jpmc_expert_consultation_all_data/', { params: { ...data } })
}

const getblrpSessionReport = (data) => {
	return axios.get('/reports/jpmc_blrp_all_data/', { params: { ...data } })
}

const umcOppurtunitiesOfUserApiAwailedDetails = (data) => {
	return axios.get("/umc_data_awailed_details/", { params: { ...data } })
}

const jpmcAddExpenseApi = (data) => {
	return axios.post("/record-transaction-jpmc-expenses/", data)
}

const getProgramManagerList = (data) => {
	return axios.get("/get_program_manager/", data)
}

const partnerDataForProgramManager = (data) => {
	return axios.get('/programmanager_entrypoint_counts/', { params: { ...data } })
}

const resourceDataForSelectedPartner = (data) => {
	return axios.get('/programmanager_resource_display_name_counts/', { params: { ...data } })
}

const programDataForProgramManager = (data) => {
	return axios.get('/programmanager_packagetitle_counts/',{ params: { ...data } })
}

const partnerDataForSelectedPro = (data) => {
	return axios.get('/programmanager_pcktitle_entrypoint_counts/', { params: { ...data } })
}

const allExpPartnerList = (data) => {
	// return axios.get("/services/fetch_ext_service_partner/?sServiceCode=EXPRTCONSULT&sServiceCode=LTEXPCOACH&sServiceCode=GRPEXPRTCONSULT", data)
	return axios.get("/services/get_all_ext_service_partner/", data)
}

// const getAllProgramManagerPartnerData = (data) => {
// 	// return axios.get('/get_partnre_programmanagerList/', data)
// 	console.log(data, ">>>> data on getAllProgramManager association")
// 	const {sProgramManager} = data;
// 	console.log(sProgramManager, ">>>>sProgramManager in api calll");
	
// 	return axios.get('/get_partnre_programmanagerList/', {
// 		params:{sProgramManager}
// 	})
// }

const getAllProgramManagerPartnerData = (data) => {
	// return axios.get('/get_partnre_programmanagerList/', data)
	console.log(data, ">>>> data on getAllProgramManager association")
	const {searchByVal, name} = data;
	console.log(searchByVal, name, ">>>>select option and name in api calll");
	
	if(searchByVal == "sProgramManager"){
		return axios.get('/get_partnre_programmanagerList/', {
			params:{sProgramManager: name}
		})
	} else if(searchByVal == "sEntryPoint"){
		return axios.get('/get_partnre_programmanagerList/', {
			params:{sEntryPoint: name}
		})
	} else {
		return axios.get('/get_partnre_programmanagerList/')
	}
	
}

const getAllProgramManagerData = (data) => {
	return axios.get('/get_program_manager_withID/', data)
}

const addProgramManager = (data) => {
	return axios.post('/add_program_manager/', data)
}

// const getAllPartnerMasterData = (data) => {
// 	return axios.get('/get_entryid_withID/', data)
// }
const getAllPartnerMasterData = (data) => {
	console.log(data, ">>>data in api file getAllPartnerMasterData new");
	const {sEntryPoint} = data;
	console.log(sEntryPoint, ">>>>sEntryPoint in api calll");
	return axios.get(`/get_entryid_withID/`, {params: {sEntryPoint}})
}

const addPartner = (data) => {
	return axios.post('/add_partner_entrypoint/', data)
}

const updateProgramManagerPartnerAssociation = (data, Pid) => {
	return axios.put(`/update_program_manager/${Pid}/`, data)
}

const addProgramManagerPartnerAssociation = (data) => {
	return axios.post('/add_program_manager_entrypoint/', data)
}

const sendCancellationMessage = (data) => {
	return axios.post("/save_umc_whatsapp_request/", data);
}

// below production changes on 19-11-2024
const getWhatsappMessageSentForCancellation = (data) => {
	console.log(">>> getWhatsappSentCancellation API called");
	console.log(data, ">>>> data as payload in API function");

	if (!data) {
		return axios.get("/get_whatsapp_canmsz_data/");
	} else {
		const { page, page_size, pagination, sMessageType, sServiceCode, sServiceDisplayName, fromDate, toDate } = data;

		const sServiceDisplayNameParam = sServiceDisplayName.join(',');

		// Build the full URL with query parameters
		return axios.get(`/get_whatsapp_canmsz_data/`, {
			params: {
				page,
				page_size,
				pagination,
				sMessageType,
				fromDate,
				toDate,
				sServiceCode: sServiceCode[0],
				sServiceDisplayName: sServiceDisplayNameParam,
			}
		});
	}
};



const getPartnerMasterList = (data) => {
	return axios.get("/reports/entrypoint_report/", data)
}

const getPartnerProgramManagerList = (data) => {
	return axios.get("/reports/entrypoint_partnername_report", data)
}

// IHCL APIS
// const mobilizationCountApi = (data) => {
// 	return axios.post("https://dev.deasra.in/wp-json/jpmc_count/", data)
// }
const ihclmobilizationCountApi = (data) => {
	return axios.get("/reports/ihcl_count/", data)
}

// const jpmcCountData = (data) => {
// 	return axios.get("/record-transaction-jpmc/", { params: { ...data } })
// }
const ihclCountData = (data) => {
	return axios.get("/record-transaction-ihcl/", { params: { ...data } })
}

const partnerWiseRecordsData = (data) => {
	return axios.get("/reports/partner_wise_report/", { params: { ...data } })
}

const partnerInverntionsAvailed = (data) => {
	return axios.get("/reports/interventions_availed_by_user/", { params: { ...data } })
}

const partnerInverntionsAvailedReport = (data = {}) => {
	return axios.get("/reports/interventions_availed_by_user_excel/", { params: { sPrograme_type: "Anek_Programe", ...data } })
}


// const totalBeneficiaryChartData = (data) => {
// 	return axios.get("/combined_jpmc_data/", { params: { ...data } })
// }
const ihcltotalBeneficiaryChartData = (data) => {
	return axios.get("/combined_ihcl_data/", { params: { ...data } })
}

// not ready
// const jpmcExpenseTableData = (data) => {
// 	return axios.get("/record-transaction-jpmc-expenses/", { params: { ...data } })
// }
const ihclExpenseTableData = (data) => {
	return axios.get("/record-transaction-ihcl-expenses/", { params: { ...data } })
}

// const getComplianceReportAPI = (data) => {
// 	return axios.get('/reports/jpmc_compliance/', { params: { ...data } })
// }
const ihclgetComplianceReportAPI = (data) => {
	return axios.get('/reports/ihcl_compliance/', { params: { ...data } })
}

// const getExpertConsultationReport = (data) => {
// 	return axios.get('/reports/jpmc_expert_consultation/', { params: { ...data } })
// }
const ihclgetExpertConsultationReport = (data) => {
	return axios.get('/reports/ihcl_expert_consultation/', { params: { ...data } })
}

// const getMobilizationReport = (data) => {
// 	return axios.get('/reports/eligible_report/', { params: { ...data } })
// }
const ihclgetMobilizationReport = (data) => {
	return axios.get('/reports/eligibleihcl_report/', { params: { ...data } })
}

// const getBlrpReport = (data) => {
// 	return axios.get('/reports/jpmc_blrp/', { params: { ...data } })
// }
const ihclgetIhclSocialMediaReport = (data) => {
	return axios.get('/reports/ihcl_social_media/', { params: { ...data } })
}

// const getGroupKnowledgeReport = (data) => {
// 	return axios.get('/reports/jpmc_group_knowledge_session/', { params: { ...data } })
// }
const ihclgetGroupKnowledgeReport = (data) => {
	return axios.get('/reports/ihcl_group_knowledge_session/', { params: { ...data } })
}


// const getGroupKnowledgeSessionReport = (data) => {
// 	return axios.get('/reports/jpmc_group_knowledge_session_all_data/', { params: { ...data } })
// }
const ihclgetGroupKnowledgeSessionReport = (data) => {
	return axios.get('/reports/ihcl_group_knowledge_session_all_data/', { params: { ...data } })
}


// const getMarketLinkageSessionReport = (data) => {
// 	return axios.get('/reports/jpmc_market_linkage_all_data/', { params: { ...data } })
// }
const ihclgetMarketLinkageSessionReport = (data) => {
	return axios.get('/reports/ihcl_market_linkage_all_data/', { params: { ...data } })
}

// const getComplianceSessionReport = (data) => {
// 	return axios.get('/reports/jpmc_compliance_all_data/', { params: { ...data } })
// }

const ihclgetComplianceSessionReport = (data) => {
	return axios.get('/reports/ihcl_compliance_all_data/', { params: { ...data } })
}


// const getExpertConsultationSessionReport = (data) => {
// 	return axios.get('/reports/jpmc_expert_consultation_all_data/', { params: { ...data } })
// }
const ihclgetExpertConsultationSessionReport = (data) => {
	return axios.get('/reports/ihcl_expert_consultation_all_data/', { params: { ...data } })
}


// const getblrpSessionReport = (data) => {
// 	return axios.get('/reports/jpmc_blrp_all_data/', { params: { ...data } })
// }
const ihclgetSocialMediaAllData = (data) => {
	return axios.get('/reports/ihcl_social_media_all_data/', { params: { ...data } })
}


// const getMarketLinkageReport = (data) => {
// 	return axios.get('/reports/jpmc_market_linkage/', { params: { ...data } })
// }
const ihclgetMarketLinkageReport = (data) => {
	return axios.get('/reports/ihcl_market_linkage/', { params: { ...data } })
}

// const getJpmcAllData = (data) => {
// 	return axios.get("/reports/jpmc_firsttimeusers/", { params: { ...data } })
// }
const getIhclAllData = (data) => {
	return axios.get("/reports/ihcl_firsttimeusers/", { params: { ...data } })
}


// const getComplianceReportDataAPI = (data) => {
// 	return axios.get('/reports/jpmc_compliance_data/', { params: { ...data } })
// }
const ihclgetComplianceReportDataAPI = (data) => {
	return axios.get('/reports/ihcl_compliance_data/', { params: { ...data } })
}

// const getGroupKnowledgeReportData = (data) => {
// 	return axios.get('/reports/jpmc_group_knowledge_session_data/', { params: { ...data } })
// }
const ihclgetGroupKnowledgeReportData = (data) => {
	return axios.get('/reports/ihcl_group_knowledge_session_data/', { params: { ...data } })
}

// const getExpertConsultationReportData = (data) => {
// 	return axios.get('/reports/jpmc_expert_consultation_data/', { params: { ...data } })
// }
const ihclgetExpertConsultationReportData = (data) => {
	return axios.get('/reports/ihcl_expert_consultation_data/', { params: { ...data } })
}

// const getMarketLinkageReportData = (data) => {
// 	return axios.get('/reports/jpmc_market_linkage_data/', { params: { ...data } })
// }
const ihclgetMarketLinkageReportData = (data) => {
	return axios.get('/reports/ihcl_market_linkage_data/', { params: { ...data } })
}


// const getBlrpReportData = (data) => {
// 	return axios.get('/reports/jpmc_blrp_data/', { params: { ...data } })
// }
const getIhclSocialMediaData = (data) => {
	return axios.get('/reports/ihcl_social_media_data/', { params: { ...data } })
}


// const mainTableData = (data) => {
// 	return axios.get("/combined_resourcedisplayname/", { params: { ...data } })
// }
const ihclmainTableData = (data) => {
	return axios.get("/combinedihcl_resourcedisplayname/", { params: { ...data } })
}

// SP UMC customer feedback screen
const getUmcFeedbackList = (perPage, currentPage, filterOptions)=> {
	console.log(filterOptions, ">>>filteroptions UMC customer feedback list api called");
	
	let params = {
		"api_key" : "r54B?rHXUE7v%$9t",
		"per_page" : perPage,
		"page" : currentPage,
		"opportunity_type": filterOptions?.type ? filterOptions?.type : "",
		"opportunity_title": filterOptions?.title?.length > 0 ? filterOptions?.title : []
	}
	return axios.post("https://www.deasra.in/wp-json/umc-feedback-list/", params)
}

const getUmcFeedbackDetail = (selectedFeedback) =>{
	let params = {
		"api_key"     : "r54B?rHXUE7v%$9t",
		"feedback_id" : selectedFeedback
	}

	return axios.post("https://www.deasra.in/wp-json/umc-get-feedback-detail/", params)
}


// SP UMC UMC Customers screen (send sms related APIs)
const getOpportunitiesListing = () =>{
	let params = {
		"api_key" : "r54B?rHXUE7v%$9t"
	}
	return axios.post("https://www.deasra.in/wp-json/GetOpportunitiesListing/", params)
}

const getSelectedOppTitleDetails = (selectedTitleOppId) => {
	let params = {
		"api_key" : "r54B?rHXUE7v%$9t",
		"opportunity_id" : selectedTitleOppId
	}

	return axios.post("https://www.deasra.in/wp-json/GetOpportunitiesDetail/", params)
}

const sendOppDetailToCustomer = (data) => {
	console.log(data, ">>>>Data in sendOppDetailToCustomer api called");
	
	return axios.post("/save_opportunity_whatsapp_request/", data)
}

// All Expert Consultation Services
const allExpertConsultationServices = (data) => {
	return axios.get("/reports/jpmc_expert_consultation_all_piechart/", { params: { ...data } })
}

// All Delivered Services By Card Titles in JPMC
const allJpmcDeliveredCounts = (data) =>{
	return axios.get("/reports/get_resource_count/", { params: { ...data } })
}

// Resource availed download API-
const eligibleReportResourceAvailed = (data) =>{
	return axios.get("/reports/eligible_report_resourceavailed/", { params: { ...data } })
}

// All Delivered Compliance Services
const allComplianceServices = (data) => {
	return axios.get("/reports/jpmc_compliance_all_piechart/", { params: { ...data } })
}

// All Delivered Group Knowledge Session Services
const allGroupKnowledgeServices = (data) => {
	return axios.get("/reports/jpmc_groupknowledge_all_piechart/", { params: { ...data } })
}

// All Delivered Digital Enablement Session Services
const allDigitalEnablementServices = (data) => {
	return axios.get("/reports/jpmc_Digital_Enablement_all_piechart/", { params: { ...data } })
}

// All Delivered Digital Enablement Session Services
const allDigitalEnablementPieChartServices = (data) => {
	return axios.get("/reports/jpmc_digital_all_piechart/", { params: { ...data } })
}

// All delivered Market Connect Services
const allMarketConnectServices = (data) => {
	return axios.get("/reports/jpmc_marketlinkage_all_piechart/", { params: { ...data } })
}

// All Delivered BLRP Piechart
const allBLRPServices = (data) => {
	return axios.get("/reports/jpmc_blrp_all_piechart/", { params: { ...data } })
}

// get opp titles on the basic of opp type
const getOppTitles = (oppType) => {
	let params = {
		"api_key" : "r54B?rHXUE7v%$9t",
		"opportunity_type": oppType
	}

	console.log(params, ">>>params in getOppTitles");
	

	return axios.post("https://www.deasra.in/wp-json/GetOpportunitiesListing/", {...params})
}

const savePaymentSettlementEmail = (data) => {
	return axios.post("/reports/save_payment_settlement_email/", data)
}

const generateAndSendReport = (data) => {
	return axios.post("/reports/generate_and_send_report/")
}


const getPendingApprovalEntryPoint = (data) => {
	return axios.get("https://expertconsultation.free.beeceptor.com/get_pending_entrypoint")
}

// APIs for Partner Master Screen
const getAllApprovalPendingPartner = () => {
	return axios.get("/get_not_approved_entryid_withID/")
}


const addPartnerForApproval = (data) => {
	return axios.post("/add_partner_entrypoint_beforeapproval/", data)
}


const getRelatedPartnerNames = (data) => {
	return axios.get(`/get_related_entrypoint/?sEntryPoint=${data}`)
}


const approvePartner = (data) => {
	return axios.post("/add_partner_entrypoint/", data)
}

const deletePendingApprovalPartner = (data) => {
	console.log(data, ">>>>delete partner data");
	
	return axios.post("/delete_entrypoint/", data)
}

const uniqueRepeatUserGroupKnowledgeSession = (data) => {
	return axios.get("/reports/get_kwnoledge_resource_unique_count/", data)
}

// jpmc three sixty degree view persona details APIs
const jpmcThreeSixtyDegreeViewGetUserDetail = (mobile) => {
	return axios.get(`/reports/get_jpmc_user_profile/?sMobile=${mobile}`)
}

const getFacilitatorDetails = (data) => {
	return axios.get("/reports/get_facilitator/", { params: { ...data } });

}

const jpmcThreeSixtyDegreeViewGetResourceCount = (mobile) => {
	return axios.get(`/reports/get_resource_count_by_user/?sMobile=${mobile}`)
}

const jpmcThreeSixtyDegreeViewGetResourceDetailedByUser = (mobile) => {
	return axios.get(`/reports/get_resource_detailed_by_user/?sMobile=${mobile}`)
}

const jpmcThreeSixtyDegreeViewGetPersonaDetails = (mobile) => {
	return axios.get(`/reports/get_persona_details/?sMobile=${mobile}`)
}

const jpmcThreeSixtyDegreeViewSavePersonaDetails = (data) => {
	return axios.post(`/reports/save_jpmc_persona/`, data)
}

const jpmcThreeSixtyDegreeViewSavePersonaDetailsVideo = (data) => {
	return axios.post(`/reports/save_jpmc_persona_testimonials/`, data, {
		headers: {
			"Content-Type": "multipart/form-data", // optional, Axios overrides it anyway
		},
	})
}

const jpmcThreeSixtyDegreeViewEditPersonaDetailsVideo = (data) => {
	return axios.post(`/reports/update_jpmc_persona_testimonials/`, data, {
		headers: {
			"Content-Type": "multipart/form-data", // optional, Axios overrides it anyway
		},
	})
}

const jpmcThreeSixtyDegreeViewDeletePersonaDetailsVideo = (data) => {
	return axios.delete(`/reports/delete_jpmc_persona_testimonials/`, {data})
}


const jpmcThreeSixtyDegreeViewUserPersonaDetailsDownload = (mobile) => {
	return axios.get(`/reports/JPMC_Persona_Details_by_Mobile/?sMobile=${mobile}`)
}

const jpmcThreeSixtyDegreeViewUserAllPersonaDetailsDownload = (mobile) => {
	return axios.get(`/reports/JPMC_Persona_all_Data/`)
}

const updatePersonaDetail = (data) => {
	return axios.post(`/reports/update_jpmc_persona/`, data)
}

// delete is used for deleting tetimonials
const jpmcThreeSixtyDegreeViewDeletePersonaDetails = (data) => {
	return axios.delete(`/reports/delete_jpmc_persona/`, {data})
}

const getAllTestimonials = (filterMobileVal) => {
	if(!filterMobileVal){
		filterMobileVal = ""
	}
	return axios.get(`/reports/get_jpmc_user/?sMobile=${filterMobileVal}`)
}

const getUserTestimonial = (mobile) => {
	console.log(mobile, ">>>>>mobile on get user testimonal api call");
	
	return axios.get(`/reports/get_jpmc_user/?sMobile=${mobile}`)
}


// Dream big API
// fisrt page
const getDreamBigFirstTimePartnerResourceData = (data) => {
	return axios.get("/record-transaction-dreambig/first_dreambigusers__entrypoint_displayname_report/", { params: { ...data } })
}

const getDreamBigEngagedPartnerResourceData = (data) => {
	return axios.get("/record-transaction-dreambig/engaged_dreambigusers_entrypoint_displayname_report/", { params: { ...data } })
}

const getDreamBigFirstTimeAnnualTurnover = (data) => {
	return axios.get("/record-transaction-dreambig/first_time_dreambigusers_turnover_report/", { params: { ...data } })
}

const getDreamBigEngagedAnnualTurnover = (data) => {
	return axios.get("/record-transaction-dreambig/engaged_dreambigusers_turnover_report/", { params: { ...data } })
}

const getengagedusercountDreamBig = (data) => {
	return axios.get("/record-transaction-dreambig/engaged_users_count_dreambigusers/", { params: { ...data } });
};

const getDreamBigTotalResourcesConsumedByUser = (data) => {
	return axios.get("/record-transaction-dreambig/dreambig_users_resource_consumed/", { params: { ...data } });
};

const getDreamBigTotalResourcesConsumedByUserBefore4thApril = (data) => {
	return axios.get("/record-transaction-dreambig/dreambig_users_resource_consumed_EUDreambig/", { params: { ...data } });
};


const getDreamBigTopResources = (data) => {
	return axios.get("/record-transaction-dreambig/ftu_engaged_dreambigusers_top_resourceID/", { params: { ...data } });
};

const getDreamBigTopSourcesBasedOnEntryPoint = (data) => {
	return axios.get("/record-transaction-dreambig/ftu_engaged_dreambigusers_top_entrypoint/", { params: { ...data } });
};

const getDreamBigFtuVehicleQuestion = (data) => {
	return axios.get("/record-transaction-dreambig/ftu_vehicle_breakup", { params: { ...data } });
};

const getDreamBigDeviceCount = (data) => {
	return axios.get("/record-transaction-dreambig/ftu_device_breakup/", { params: { ...data } });
};

// const getDreamBigVehicleDeviceCombinationCount = (data) => {
// 	console.log(data, ">>>>data in getDreamBigVehicleDeviceCombinationCount")
// 	return axios.get("/record-transaction-dreambig/ftu_vehicle_device_combinations/", { params: { ...data } });
// };

const getDreamBigVehicleDeviceCombinationCount = (params) => {
    const queryString = buildQueryString(params);
    return axios.get(`/record-transaction-dreambig/ftu_vehicle_device_combinations/?${queryString}`);
};


// second page
const getProgramManagerListDreamBigUser = (data) => {
	return axios.get("/get_program_manager_dreambiguser/", data)
}

const partnerDataForProgramManagerDreamBigUser = (data) => {
	return axios.get('/programmanager_entrypoint_counts_dreambigusers/', { params: { ...data } })
}

const entryPointDataForProgramManagerDreamBigUser = (data) => {
	return axios.get('/get_program_manager_dreambiguser_with_partner/', { params: { ...data } })
}

const getVehicleData = (data) => {
	return axios.get('/get_all_vehicle_data/', { params: { ...data } })
}


const getFTCDataByProgramManager = (data) => {
	return axios.post(`/get_ftc_by_pm_and_partner_with_alldata/`, data)

}


const programDataForProgramManagerDreamBigUser = (data) => {
	return axios.get('/programmanager_packagetitle_counts_dreambigusers/',{ params: { ...data } })
}

const resourceDataForSelectedPartnerDreamBigUser = (data) => {
	return axios.get('/programmanager_resource_display_name_counts_dreambigusers/', { params: { ...data } })
}

const getDreamBigFirstUserAllFiltertable = (data) => {
	console.log(">>>>>>getDreamBigFirstUserAllFiltertable api called")
	return axios.get(`/record-transaction-dreambig/first_dreambigusers__all_filter/`, { params: { ...data } })
}

const getDreamBigEngagedUserAllFiltertable = (data) => {
	console.log(">>>>>>getDreamBigEngagedUserAllFiltertable api called")
	return axios.get(`/record-transaction-dreambig/engaged_dreambigusers__all_filter/`, { params: { ...data } })
}

//  service catalogue API
const deliveryModeDropdownData = (data) => {
	return axios.get("/delivery_mode/", data)
}

const paymentModeDropdwonData = (data) => {
	return axios.get("/payment_mode/", data)
}

const paymentRecieverDropdownData = (data) => {
	return axios.get("/payment_receiver/", data)
}

const sModeDropdownData = (data) => {
	return axios.get("/service_smode/", data)
}

const serviceCodeDropdownData = (data) => {
	return axios.get("/sservicecode/", data)
}

const getServiceCatalogueData = (data) => {
	return axios.get("/service_catelouge/", data)
}

const updateServiceCatalogueData = (data, Rid) => {
	return axios.put("/service_catelouge/", data, { params: { id: Rid } })
}

const addServiceCatalogueData = (data) => {
	return axios.post("/service_catelouge/", data)
}

// Resource master API
const resourceTypeDropdownData = (data) => {
	return axios.get("/resource_type/", data)
}

const resourceSubtypeDropdownData = (data) => {
	return axios.get("/resource_sub_type", data)
}

const getResourceMasterData = (data) => {
	return axios.get("/resource_master/", data)
}

const addResourceMasterData = (data) => {
	return axios.post("/resource_master/", data)
}

const updateResourceMasterData = (data, Rid) => {
	return axios.put("/resource_master/", data, { params: { id: Rid } })
}

const deleteResourceMasterData = (data) => {
	return axios.delete("/resource_master/", { params: { ...data } })
}

// Manage external partner APIs
const serviceNameDropdownData = (data) => {
	return axios.get("/service_code/", data)
}

const getServiceTableData = (code) => {
	return axios.get("/service_providers/", { params: { sServiceCodes: code } })
}

const getServicePartnerDropdownData = (data) => {
	return axios.get("/service_partners_list/", data)
}

const associatePartner = (data, pid) => {
	return axios.put("/service_partners_servicecode/", data, { params: { id: pid } })
}

const updateServicePartnerDropdownData = (data, Pid) => {
	return axios.put("/service_partners_list/", data, { params: { id: Pid } })
}

const addServicePartnerDropdownData = (data) => {
	return axios.post("/service_partners_list/", data)
}

const disassociatePartner = (data, pid) => {
	return axios.put("/service_partners_servicecode_delete/", data, { params: { id: pid } })
}

const getMyServiceRequestsFacilitatorExpand = (
	nResourceInstanceId

) => {
	return axios.get("services/fetch_my_services/", {
		params: { 
			// page: page,
			// page_size: page_size,
			nResourceInstanceId: nResourceInstanceId },
	});
};

const getDistinctResourceDisplayNames = (data) => {
	return axios.get(`/get_distinct_resource_display_names/`,{
		params: { 
			// page: page,
			// page_size: page_size,
			sResourceDisplayName: data },
	})
}

const getUserCountsByResource = (data) => {
	return axios.get(`/get_user_counts_by_resource`,   { params: { ...data } })

  };

const getLandingPageVehicleData = (data) => {
	return axios.get('/get_answer_breakdown_by_resource/', { params: { ...data } })
}

const getFacilitatorList = (data) => {
	return axios.get('/reports/get_facilitator_outofoffice/', { params: { ...data } })
}

const saveFacilitator = (data) => {
	return axios.post(`/reports/save_facilitator_assign/`, data)

}

const getSourceList= (data) => {
	return axios.get('/reports/get_source_list/',data)
}


const api = {
	GRPExpConsultServicePartners,
	ExpConsultServicePartners,
	LTExpCoachServicePartners,
	getCancellationReasons,
	searchServiceById,
	getAllServiceActions,
	getFacilitatorServiceActions,
	getUserMetaChangeLog,
	findDetailsWithPincode,
	saveBusinessProfile,
	downloadOutboundLogs,
	generateOutboundCallingLog,
	getleadDetails,
	getExternalServicePartners,
	getUserProfileSupportedStatusHistory,
	getMyServiceRequestsFacilitatorDueToday,
	getMyServiceRequestsFacilitatorOverdue,
	searchServiceRequestsSPM,
	getAuditTrailNotesSPM,
	getStateAuditLogSPM,
	setServiceCancelled,
	setServiceDelivered,
	setFullPaymentComplete,
	setFullPaymentRequested,
	setServiceDeliverablesReady,
	setServiceDeliveryStarted,
	setPaymentConfirmedbyPartner,
	saveServicePartner,
	getServicePartners,
	sendPaymentLinkSPM,
	updateNotes,
	saveNeftDetailsSPM,
	saveNotes,
	getNotesHistory,
	getMyServiceRequestsFacilitator,
	assignFacilitator,
	getAllFacilitators,
	getAllServicesSPM,
	forgotPassword,
	login,
	logout,
	setPassword,
	getUsers,
	loginWithGoogle,
	setNewPasswordPostForgot,
	changePassword,
	handleError,
	requestResetPassword,
	resetPassword,
	getUserRoles,
	createUser,
	getAllServiceRequests,
	assignHandholder,
	getAllHandholders,
	getAllServiceRequestsNames,
	getMyServiceRequests,
	updateUser,
	deactivateUser,
	deactivateUserNew,
	updateServiceRequest,
	getAllServiceRequestsStatus,
	getMasterServiceTypes,
	getMasterServiceStates,
	getMasterServiceRequestStates,
	getAuditLog,
	searchServiceRequests,
	sendPaymentLink,
	changeServiceRequestState,
	getServiceRequestById,
	getCatalogueForServiceRequest,
	saveCatalogueForServiceRequest,
	saveNeftDetails,
	getUserProfileData,
	getUserProfileWP,
	saveUserProfileData,
	reactivateUser,
	markInOffice,
	loginWithSso,
	getAllServicesReport,
	getFullfillmentReport,
	getTicketLevelLog,
	getAllServicesReportView,
	getUserRoleAccessReport,
	getRoleAccessReport,
	getAuditLogReport,
	getServiceCatalogueReport,
	getServiceActionReport,
	getKRAReport,
	getStateAuditLog,
	updateUserId,
	downloadResourceData,
	generateCallingReport,
	getPaymentTrackerReport,
	getNeftAccountDetails,
	sendNeftAccountDetails,
	assignToMe,
	getDisableFalseServiceRequestsNames,
	getDNDDate,
	saveRefundDetails,
	getAllPackageCatalogues,
	createPackageCatalogue,
	getAllServiceCatalogues,
	getAllExternalServicePartners,
	getPackageMappedServices,
	mapPackageServices,
	updatePackageCatalogue,
	deletePackageMappedService,
	getExternalPartnerServices,
	sendOTPToESP,
	loginESPWithOTP,
	updateOtherServiceInfo,
	setAwaitingForInformationDocuments,
	addESPServiceCharges,
	updateESPServiceCharges,
	addESPNotes,
	getESPNotesLogByServiceId,
	updateNeedtoTalkToSPFlagSPM,
	updateCallStatus,
	sendClaimFreeListingSMSToUser,
	updateNewNotesFlag,
	getExternalPartnerServicesDashboradData,
	getExternalPartnerServicesDashboradDataNew,
	getExternalPartnerServicesChartData,
	getExternalPartnerServicesCountData,
	getUserQuestionnaire,	
	updateUserQuestionaireData,
	getUserBusinessQuestionnaire,
	updateUserBusinessQuestionaireData,
	getUserAllServiceFeedbackData,
	getUserServiceFeedbackData,
	getImpactMetricReport,
	getImpactMetricTransactionReport,
	getEngagementReport,
	getUserFeedbackReport,
	getNotesLogByEmailId,
	updatedePrenuerDetails,
	getFacilitatorKRADashboardData,
	UploadAdminKRAReport,
	getFacilitatorManagersKRADashboardData,
	getProfileSearchFields,
	getUserProfileSearchReport,
	updatedePrenuerBusinessData,
	updatedePrenuerServiceVerifiedFlag,
	getActiveHHAndFacilitator,
	sendFollowupSMS,
	getESPSMSLogByServiceId,
	getAllFollowupSMSByUserid,
	getSMSTrailReport,
	getCustomerFeedbackList,
	getFirstTimeResponseData,
	getCustomerSatisfactionScoreData,
	getCustomerFeedbackReport,
	getCustomerFRTReport,
	getUMCReport,
	sendFeedbackLinkToUser,
	getServiceDetailsSPMByInstanceID,
	getServiceDetailsLPMByInstanceID,
	getUnreadFeedbackCount,
	uploadAssignFacilitatorData,	
	getKRADashboardReport,
	UploadStatusProgressionSheet,
	updateNeedToTalkToSPFlagFromSPLed,
	updateSPFollowUpData,
	getDNDUsersList,
	getSPLedFollowUps,
	saveESPTargets,
	getServiceRequests,
	getServicesSPM,
	get2_plus_3_plusReport,
	getToolsTemplateList,
	searchToolsTemplateRequests,
	getToolTemplatesRequests,
	getAllToolsTemplatesRequests,
	getMyResourceToolsTemplates,
	getToolsTemplatesDueToday,
	getToolsTemplatesOverdue,
	//getCatalogueForToolsTemplates,
	//getAllPackageToolsTemplates,
	assignFacilitatorfortooltemplates,
	getToolsTemplatesTool,
	getToolsTemplatesTemplate,
	//getToolsTmpaltesNotesHistory,
	saveToolsTemplatesNotes,
	//updateToolsTemplatesNotes,
	getFacilitatorToolsTemplatesAction,
	getNotesfortooltemplates,
	getFacilitatorCallReport,
	getengagedusercount,
	getFirstTimeusersDashboradData,
	getEngagedusersDashboradData,
	updateOfflineMeet,
	getEngagedUserReport,
	setInfoDocsReceived,
	getAllExpertCalenderList,
	bookExpertAppointment,
	LTExpServicePartners,
	updateExternalServicePartner,
	getAllExpertAppointmentList,
	getExpertById,
	getExpertInfo,
	deleteExpertAppointment,
	getFacilitatorCount,
	getSingleUserFacilitatorData,
	getMultipleUserFacilitatorData,
	addExpertSlots,
	deleteExpertSlots,
	getSpeakerList,
	// getVerifiedStatus,
	getFirstTimeUserReport,
	getFirstTimeUserPartnerData,
	getEngagedUserPartnerData,
	getFirstTimeAnnualTurnover,
	getEngagedAnnualTurnover,
	getFirstTimeSourceMediumData,
	getEngagedSourceMediumData,
	getFirstTimeUserChartData,
	getEngagedUserChartData,
	getResourceAwailedChartData,
	getMonthWiseData,
	getResourceCount,
	getFirstTimeProgramData,
	getEngagedUserProgramData,
	getFilterProgramData,
	getFilterPartnerData,
	updatePriceApi,
	getFirstTimePartnerResourceData,
	getEngagedPartnerResourceData,
	applyDiscountAPI,
	getFirstTimeProgramResourceData,
	getEngagedProgramResourceData,
	allExtPartnerList,
	getServiceForSettlement,
	updateSettlementInvoice,
	monthlyPaymentTrackerReport,
	newDeactivateUser,
	newMarkInOffice,
	ageWiseData,
	sectorWiseData,
	familyIncomeData,
	businessIncomeData,
	mainTableData,
	jpmcCountData,
	partnerWiseRecordsData,
	partnerInverntionsAvailed,
	partnerInverntionsAvailedReport,
	anekCountData,
	totalBeneficiaryChartData,
	jpmcExpenseTableData,
	getPrimeSubscriberList,
	getPrimeServiceList,
	getPrimeMarketLinkageList,
	closeService,
	getCloseServicesData,
	openService,
	createNewServiceApi,
	sendErrorEmail,
	getComplianceReportAPI,
	getExpertConsultationReport,
	getBlrpReport,
	getMobilizationReport,
	getGroupKnowledgeReport,
	getMarketLinkageReport,
	getJpmcAllData,
	mobilizationCountApi,
	mobilizationCountAnekApi,
	getComplianceReportDataAPI,
	getExpertConsultationReportData,
	getBlrpReportData,
	getMarketLinkageReportData,
	getGroupKnowledgeReportData,
	getMyServiceRequestNew,
	getServiceMoreDetails,
	umcOppurtunitiesOfUserApi,
	catalogueLinkApi,
	updateConfirmationFlagSPM,
	updateConfirmationFlagLPM,
	oppTypeListApi,
	oppTitleListApi,
	deliverBulkServiceData,
	cancelBulkServiceData,
	getExternalPartnerUmcServices,
	umcDataReport,
	addRevenueUmc,
	businessSectorListApi,
	tagsListApi,
	fetchTagsByUserId,
	saveTagsApi,
	getExternalPartnerFilterConfirmationTag,
	businessCityListApi,
	umcCustomersAPI,
	umcCustomerDownlaodApi,
	getGroupKnowledgeSessionReport,
	getMarketLinkageSessionReport,
	getComplianceSessionReport,
	getExpertConsultationSessionReport,
	getblrpSessionReport,
	umcOppurtunitiesOfUserApiAwailedDetails,
	jpmcAddExpenseApi,
	partnerDataForProgramManager,
	getProgramManagerList,
	resourceDataForSelectedPartner,
	programDataForProgramManager,
	partnerDataForSelectedPro,
	allExpPartnerList,
	getAllProgramManagerPartnerData,
	getAllProgramManagerData,
	updateProgramManagerPartnerAssociation,
	addProgramManagerPartnerAssociation,
	addProgramManager,
	getAllPartnerMasterData,
	addPartner,
	umcOppurtunitiesOfUserApiAllDetails,
	sendCancellationMessage,
	getWhatsappMessageSentForCancellation,
	getPartnerMasterList,
	getPartnerProgramManagerList,
	// ihcls apis
	ihclCountData,
	ihcltotalBeneficiaryChartData,
	ihclExpenseTableData,
	ihclgetComplianceReportAPI,
	ihclgetExpertConsultationReport,
	ihclgetMobilizationReport,
	ihclgetIhclSocialMediaReport,
	ihclgetGroupKnowledgeReport,
	ihclgetGroupKnowledgeSessionReport,
	ihclgetMarketLinkageSessionReport,
	ihclgetComplianceSessionReport,
	ihclgetExpertConsultationSessionReport,
	ihclgetSocialMediaAllData,
	ihclgetMarketLinkageReport,
	getIhclAllData,
	ihclgetComplianceReportDataAPI,
	ihclgetGroupKnowledgeReportData,
	ihclgetExpertConsultationReportData,
	ihclgetMarketLinkageReportData,
	getIhclSocialMediaData,
	ihclmainTableData,
	ihclmobilizationCountApi,
	productListApi,
	getUmcFeedbackList,
	getUmcFeedbackDetail,
	getOpportunitiesListing,
	getSelectedOppTitleDetails,
	sendOppDetailToCustomer,
	allExpertConsultationServices,
	allJpmcDeliveredCounts,
	eligibleReportResourceAvailed,
	allComplianceServices,
	allGroupKnowledgeServices,
	allMarketConnectServices,
	getOppTitles,
	allBLRPServices,
	savePaymentSettlementEmail,
	generateAndSendReport,

	getPendingApprovalEntryPoint,

	getAllApprovalPendingPartner,
	addPartnerForApproval,
	getRelatedPartnerNames,

	deletePendingApprovalPartner,
	approvePartner,

	uniqueRepeatUserGroupKnowledgeSession,

	jpmcThreeSixtyDegreeViewGetUserDetail,
	getFacilitatorDetails,
	jpmcThreeSixtyDegreeViewGetResourceCount,
	jpmcThreeSixtyDegreeViewGetResourceDetailedByUser,

	jpmcThreeSixtyDegreeViewGetPersonaDetails,
	jpmcThreeSixtyDegreeViewSavePersonaDetails,
	jpmcThreeSixtyDegreeViewSavePersonaDetailsVideo,
	jpmcThreeSixtyDegreeViewEditPersonaDetailsVideo,
	jpmcThreeSixtyDegreeViewDeletePersonaDetailsVideo,
	jpmcThreeSixtyDegreeViewUserPersonaDetailsDownload,
	jpmcThreeSixtyDegreeViewUserAllPersonaDetailsDownload,
	updatePersonaDetail,
	jpmcThreeSixtyDegreeViewDeletePersonaDetails,
	getAllTestimonials,
	getUserTestimonial,

	getDreamBigFirstTimePartnerResourceData,
	getDreamBigEngagedPartnerResourceData,
	getDreamBigFirstTimeAnnualTurnover,
	getDreamBigEngagedAnnualTurnover,
	getengagedusercountDreamBig,
	getDreamBigTotalResourcesConsumedByUser,
	getDreamBigTotalResourcesConsumedByUserBefore4thApril,
	getDreamBigTopResources,
	getDreamBigTopSourcesBasedOnEntryPoint,
	getDreamBigFtuVehicleQuestion,
	getDreamBigDeviceCount,
	getDreamBigVehicleDeviceCombinationCount,

	getProgramManagerListDreamBigUser,
	partnerDataForProgramManagerDreamBigUser,
	programDataForProgramManagerDreamBigUser,
	resourceDataForSelectedPartnerDreamBigUser,
	getDreamBigFirstUserAllFiltertable,
	getDreamBigEngagedUserAllFiltertable,

	// service catalogue API
	deliveryModeDropdownData,
	paymentModeDropdwonData,
	paymentRecieverDropdownData,
	sModeDropdownData,
	serviceCodeDropdownData,
	getServiceCatalogueData,
	updateServiceCatalogueData,
	addServiceCatalogueData,
	resourceTypeDropdownData,
	resourceSubtypeDropdownData,
	getResourceMasterData,
	addResourceMasterData,
	updateResourceMasterData,
	deleteResourceMasterData,
	serviceNameDropdownData,
	getServiceTableData,
	getServicePartnerDropdownData,
	associatePartner,
	updateServicePartnerDropdownData,
	addServicePartnerDropdownData,
	disassociatePartner,
	getMyServiceRequestsFacilitatorV1,
	getMyServiceRequestsFacilitatorExpand,
	entryPointDataForProgramManagerDreamBigUser,
	getFTCDataByProgramManager,
	getVehicleData,
	allDigitalEnablementServices,
	getDigitalEnablementReportData,
	getDEPSessionReport,
	getDepReport,
	allDigitalEnablementPieChartServices,
	getDistinctResourceDisplayNames,
	getUserCountsByResource,
	getLandingPageVehicleData,
	getFacilitatorList,
    saveFacilitator,
	getSourceList
};

export default api;